import { IconDownload, Tooltip } from '@issuu/silkscreen';
import React, { useCallback, useContext } from 'react';

import { download } from '../../api';
import DocumentContext from '../DocumentPage/DocumentContext';
import { ActionButton, ActionIcon } from './ActionButton';

export const useDocumentDownloader = (username: string, documentName: string): (() => void) =>
    useCallback(() => {
        download(username, documentName).then(({ url }) => window.open(url, '_top'));
    }, []);

const Download: React.FC = () => {
    const {
        document: { documentName, downloadable },
        publisher: {
            username,
            licenses: { download: licenseToDownload },
        },
    } = useContext(DocumentContext);

    const downloadDocument = useDocumentDownloader(username, documentName);

    const downloadText = !licenseToDownload
        ? 'The publisher does not have the license to enable download'
        : !downloadable
        ? 'The publisher chose not to allow downloads for this publication'
        : 'Download the publication';

    return (
        <Tooltip id="download_tooltip" size="medium" text={downloadText}>
            <ActionButton
                aria-describedby="download_tooltip"
                disabled={!downloadable || !licenseToDownload}
                onClick={downloadDocument}
            >
                <ActionIcon>
                    <IconDownload />
                </ActionIcon>
                Download
            </ActionButton>
        </Tooltip>
    );
};

export default Download;
